// @flow
import ResourceModel from "../base/ResourceModel";
import LookupOptionCollection from "../lookup/LookupOptionCollection";
import FilterCollection from "../filters/FilterCollection";

import type { ModularUIResponse } from "../../modularui";

/**
 */
export default class LookupOptionsModel extends ResourceModel {
  _options: LookupOptionCollection;
  _filterCollection: ?FilterCollection;

  /**
   */
  constructor(modularuiResponse: ModularUIResponse) {
    super(modularuiResponse);

    this._options = LookupOptionCollection.create(
      this.data,
      this.contributions,
      this.modelOptions,
    );

    this._filterCollection = this.createFilterCollection(
      this.data.filter,
      this.contributions.filter,
    );
  }

  /**
   */
  get type(): string {
    return "LookupOptions";
  }

  /**
   */
  static get modelName(): string {
    return "LookupOptionsModel";
  }

  /**
   */
  static isApplicableModel(data: ModularUIResponse): boolean {
    return (
      data.contributions.resourcetype &&
      data.contributions.resourcetype === "lookupOptions"
    );
  }

  /**
   */
  get options(): LookupOptionCollection {
    return this._options;
  }

  /**
   */
  createFilterCollection(
    data: Object,
    contributions: Object,
  ): FilterCollection {
    if (data && contributions) {
      return new FilterCollection(
        { [data.name]: data },
        { filter: contributions },
        this.modelOptions,
      );
    }

    return new FilterCollection();
  }

  /**
   * Getting the filters
   */
  get filterCollection(): ?FilterCollection {
    return this._filterCollection;
  }
}
